var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { SsoConfiguration } from "@/app/api/battery-portal-api";
let CompanySsoConfigurationVue = class CompanySsoConfigurationVue extends Vue {
    constructor() {
        super(...arguments);
        this.config = new SsoConfiguration();
        this.showValidation = false;
        this.scopesString = "openid, profile, email";
        this.showAdvancedSettings = false;
        // Role mappings
        this.administratorRole = "";
        this.powerUserRole = "";
        this.clientRole = "";
        this.clientAdministratorRole = "";
        this.clientInstallerRole = "";
    }
    created() {
        this.initializeDefaults();
    }
    initializeDefaults() {
        if (!this.config.callbackPath) {
            this.config.callbackPath = "/signin-oidc";
        }
        if (!this.config.userNameClaimType) {
            this.config.userNameClaimType = "preferred_username";
        }
        if (!this.config.emailClaimType) {
            this.config.emailClaimType = "email";
        }
        if (!this.config.firstNameClaimType) {
            this.config.firstNameClaimType = "given_name";
        }
        if (!this.config.lastNameClaimType) {
            this.config.lastNameClaimType = "family_name";
        }
        if (!this.config.rolesClaimType) {
            this.config.rolesClaimType = "roles";
        }
        if (this.config.scopes && this.config.scopes.length > 0) {
            this.scopesString = this.config.scopes.join(", ");
        }
        // Initialize roles dictionary if not exists
        if (!this.config.roles) {
            this.config.roles = {};
        }
    }
    onSsoEnabledChanged() {
        if (this.config.ssoEnabled) {
            this.initializeDefaults();
        }
    }
    validateSubdomain() {
        if (this.config.subdomain) {
            // Convert to lowercase and remove invalid characters
            this.config.subdomain = this.config.subdomain.toLowerCase().replace(/[^a-z0-9-]/g, '');
        }
    }
    validate() {
        this.showValidation = true;
        if (!this.config.ssoEnabled) {
            return true; // No validation needed when SSO is disabled
        }
        // Required fields when SSO is enabled
        const isValid = !!(this.config.authority &&
            this.config.subdomain &&
            this.config.clientId &&
            (this.isNewSsoConfig ? this.config.clientSecret : true));
        return isValid;
    }
    getSsoConfiguration() {
        var _a, _b, _c, _d, _e;
        // Parse scopes from comma-separated string
        if (this.scopesString) {
            this.config.scopes = this.scopesString
                .split(',')
                .map(s => s.trim())
                .filter(s => s.length > 0);
        }
        // Build roles dictionary from individual role inputs
        this.config.roles = {};
        // In cloud hosting mode, do not allow Administrator or PowerUser roles
        if (!this.isCloudHosting) {
            if ((_a = this.administratorRole) === null || _a === void 0 ? void 0 : _a.trim()) {
                this.config.roles["Administrator"] = this.administratorRole.trim();
            }
            if ((_b = this.powerUserRole) === null || _b === void 0 ? void 0 : _b.trim()) {
                this.config.roles["PowerUser"] = this.powerUserRole.trim();
            }
        }
        if ((_c = this.clientRole) === null || _c === void 0 ? void 0 : _c.trim()) {
            this.config.roles["Client"] = this.clientRole.trim();
        }
        if ((_d = this.clientAdministratorRole) === null || _d === void 0 ? void 0 : _d.trim()) {
            this.config.roles["ClientAdministrator"] = this.clientAdministratorRole.trim();
        }
        if ((_e = this.clientInstallerRole) === null || _e === void 0 ? void 0 : _e.trim()) {
            this.config.roles["ClientInstaller"] = this.clientInstallerRole.trim();
        }
        this.config.companyId = this.companyId;
        return this.config;
    }
    setSsoConfiguration(ssoConfig) {
        if (ssoConfig) {
            this.config = ssoConfig;
            if (ssoConfig.scopes && ssoConfig.scopes.length > 0) {
                this.scopesString = ssoConfig.scopes.join(", ");
            }
            // Extract individual role mappings
            if (ssoConfig.roles) {
                this.administratorRole = ssoConfig.roles["Administrator"] || "";
                this.powerUserRole = ssoConfig.roles["PowerUser"] || "";
                this.clientRole = ssoConfig.roles["Client"] || "";
                this.clientAdministratorRole = ssoConfig.roles["ClientAdministrator"] || "";
                this.clientInstallerRole = ssoConfig.roles["ClientInstaller"] || "";
            }
            this.initializeDefaults();
        }
        else {
            this.config = new SsoConfiguration();
            this.config.ssoEnabled = false;
            this.administratorRole = "";
            this.powerUserRole = "";
            this.clientRole = "";
            this.clientAdministratorRole = "";
            this.clientInstallerRole = "";
            this.initializeDefaults();
        }
        this.showValidation = false;
    }
    get isNewSsoConfig() {
        return !this.config.companyId || this.config.companyId <= 0;
    }
    get subdomainPreview() {
        const subdomain = this.config.subdomain || "[subdomain]";
        const hostParts = window.location.host.split('.');
        const baseUrl = hostParts.slice(1).join('.');
        return `https://${subdomain}.${baseUrl}`;
    }
    get callbackUrlPreview() {
        const subdomain = this.config.subdomain || "[subdomain]";
        const hostParts = window.location.host.split('.');
        const baseUrl = hostParts.slice(1).join('.');
        const callbackPath = this.config.callbackPath || "/signin-oidc";
        return `https://${subdomain}.${baseUrl}${callbackPath}`;
    }
    onEnabledChanged(newVal) {
        if (newVal) {
            this.showValidation = false;
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Number)
], CompanySsoConfigurationVue.prototype, "companyId", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CompanySsoConfigurationVue.prototype, "isCloudHosting", void 0);
__decorate([
    Watch("config.ssoEnabled"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CompanySsoConfigurationVue.prototype, "onEnabledChanged", null);
CompanySsoConfigurationVue = __decorate([
    Component({
        name: "CompanySsoConfigurationVue"
    })
], CompanySsoConfigurationVue);
export default CompanySsoConfigurationVue;
